import { render, staticRenderFns } from "./ProgressRing.vue?vue&type=template&id=2120b9a2&scoped=true"
import script from "./ProgressRing.vue?vue&type=script&lang=js"
export * from "./ProgressRing.vue?vue&type=script&lang=js"
import style0 from "./ProgressRing.vue?vue&type=style&index=0&id=2120b9a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2120b9a2",
  null
  
)

export default component.exports